import { defineComponent as _defineComponent } from 'vue';
import Popper from "@/components/Popper/Popper.vue";
import { ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ContextMenu',
    props: {
        visible: { type: Boolean },
        x: null,
        y: null
    },
    emits: ["hide"],
    setup(__props, { emit }) {
        const props = __props;
        const placeContextMenu = ref({ left: "", top: "" });
        watch(() => [props.x, props.y], () => {
            placeContextMenu.value.left = `${props.x}px`;
            placeContextMenu.value.top = `${props.y}px`;
        });
        return { __sfc: true, props, emit, placeContextMenu, Popper };
    }
});
